module.exports = __webpack_public_path__ + "static/media/signage-indoor-img8.25b6411c.jpg";